/** Resolves tonal semantic colors when a consumer cannot render Decoration directly. */
export function getDecorationTonalStyle(color) {
    return {
        backgroundColor: `var(--decoration-${color}-bg-subtle)`,
        foregroundColor: `var(--decoration-${color}-fg-primary)`,
    };
}
export function getDecorationBackgroundColor(color) {
    return `var(--decoration-${color}-bg-strong)`;
}
//# sourceMappingURL=colors.js.map